import { RootState } from "../../../../../models";
import { VasOffering } from "../../../../../models/state";

export const getAdditionalProducts = (state: RootState, memberId: string): VasOffering[] => {
    return state.retailer?.additionalProducts?.[memberId]?.products || [];
};

export const getAddedAdditionalProducts = (state: RootState, memberId: string): VasOffering[] => {
    return state.retailer?.additionalProducts?.[memberId]?.addedProducts || [];
};

export const getAdditionalProductsLoading = (state: RootState, memberId: string): boolean => {
    return state.retailer?.additionalProducts?.[memberId]?.isLoading || false;
};

export const getAdditionalProductsError = (state: RootState, memberId: string): string | undefined => {
    return state.retailer?.additionalProducts?.[memberId]?.error;
};

export const getExtraDataSimPrice = (state: RootState, memberId?: string) => {
    if (!memberId) {
        return undefined;
    }
    return state.retailer?.additionalProducts?.[memberId]?.extraSim?.dataSimPrice;
};
export const getExtraTvillingSimPrice = (state: RootState, memberId?: string) => {
    if (!memberId) {
        return undefined;
    }
    return state.retailer?.additionalProducts?.[memberId]?.extraSim?.tvillingSimPrice;
};
export const getHasExistingExtraDataSim = (state: RootState, memberId?: string) => {
    if (!memberId) {
        return undefined;
    }
    return state.retailer?.additionalProducts?.[memberId]?.extraSim?.hasExistingExtraDataSim;
};
